export default "__VITE_ASSET__D47wL8cc__"